export default {
  methods: {
    getDescriptionFromCode(code, list, ...args) {
      if (code) {
        const find = list.find(e => e.code === code);
        return find ? (find.description || find.name) : code;
      }
      return args.length > 0 ? args[0] : null;
    },
  },
};
